export default [{
    type: 'platform',
    name: 'sinoverse',
    desc: '中天宇信平台',
    models: [{
        type: 'model',
        name: 'house',
        desc: '室内集成型，每套设备安装于某个特定地块（温室、大棚），与地块1对1',
        slot: 'land',
        clazz: 'a1'
      },
      {
        type: 'model',
        name: 'meteo',
        desc: '室外气象型，整个园区使用0~1套，不关联到地块',
        slot: 'park',
        clazz: 'a2'
      },
      {
        type: 'model',
        name: 'irrigate',
        desc: '水肥机，整个园区使用0~N套，按支路与地块关联，暂时只支持1个支路',
        slot: 'branch-land',
        branchNumber: 1,
        clazz: 'a3'
      }
    ]
  },
  {
    type: 'platform',
    name: 'iav',
    desc: '智慧农业谷平台',
    models: [{
        type: 'model',
        name: 'house',
        desc: '室内集成型，每套设备安装于某个特定地块（温室、大棚），与地块1对1',
        slot: 'land',
        clazz: 'b1'
      },
      {
        type: 'model',
        name: 'irrigate',
        desc: '水肥机，整个园区使用0~N套，按支路与地块关联，暂时支持10个支路',
        slot: 'branch-land',
        branchNumber: 10,
        clazz: 'b2'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/common/device-profile.js